import { workerGA4 } from '../../analytics/workerGA4Analytics';
import { workerClarity } from './clarityAnalytics';
import { isGa4Allowed, whenAnalyticsAllowed } from './consentGate';

/**
 * GA4 + Clarity: right now when analytics is allowed, or the moment the visitor
 * accepts in the consent bar. Never on decline / GPC, and GA4 never in a
 * provider-launched session. The page_view is the consent gate's GA4 config.
 */
export function startAnalytics(userId: string | null): void {
  whenAnalyticsAllowed(() => {
    if (isGa4Allowed()) {
      workerGA4.initialize();
      if (userId) workerGA4.setUserId(userId);
    }

    workerClarity.initialize().then(() => {
      if (userId) {
        const workerId = window.location.hostname.split('.')[0]; // Extract worker ID from subdomain
        workerClarity.trackWorkerEvents.sessionStarted(userId, workerId);
      }
    }).catch(() => { /* blocked by the browser */ });
  });
}
